export default __webpack_public_path__ + "static/media/video-camera.a4d3e973.svg";